<template>
  <div class="contentArea">
    <AgGrid />
  </div>
</template>

<script>
import AgGrid from "../elements/ag-grid-table/AgGridTable.vue";
export default {
  mounted() {
    this.$store.dispatch("general/get_AdminTable");
    this.$store.dispatch("general/push_pointer", "admin");
  },
  components: {
    AgGrid
  }
};
</script>

<style lang="scss" scoped></style>
